/* De client waarmee het CRM ems en de sites leest: de gewone CRM-client, dus de
 * sessie van de ingelogde gebruiker. Geen service-sleutel, geen aparte rol.
 *
 * CRM-deel (ADR 0010). Dit is de enige plek in src/features/ems/ die de
 * Supabase-client importeert; de hooks en de schermen krijgen hem als argument,
 * zodat ze ook met een nagebootste transportlaag te tekenen zijn. */

import { supabase } from '@/integrations/supabase/client';
import type { EmsClient } from './leesEms';

/** ems via .schema('ems'), public via .from(). */
export type CrmLeesClient = EmsClient & { from(tabel: string): any };

/* De gegenereerde types kennen alleen public; ems staat buiten types.ts. */
export const crmClient = supabase as unknown as CrmLeesClient;
